// Navigation Links
export const navLinks = [
    { path: '/', label: 'Home' },
    { path: '/about', label: 'About' },
    { path: '/services', label: 'Services' },
];

export const footerLinks = {
    company: [
        { path: '/about', label: 'About Us' },
        { path: '/services', label: 'Services' },
        { path: '/contact', label: 'Contact' },
    ],
    services: [
        { path: '/services#training', label: 'AI Software Training' },
        { path: '/services#compliance', label: 'Compliance Consulting' },
        { path: '/services#cctv', label: 'AI-Powered CCTV' },
    ],
    legal: [
        { path: '/privacy', label: 'Privacy Policy' },
        { path: '/terms', label: 'Terms of Service' },
    ],
};

export default navLinks;
